import {Component, OnInit} from '@angular/core';
import {DataService} from 'projects/firebase/src/lib/services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {filter, interval, map, mergeMap, startWith, Subscription, take} from 'rxjs';
import {GoogleTagService} from '../../../../../shared/src/lib/services/google-tag.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';

@Component({
    selector: 'app-after-payment',
    templateUrl: './after-payment.component.html',
    styleUrls: ['./after-payment.component.scss']
})
export class AfterPaymentComponent implements OnInit {
    returnUrl = '/cs';

    statusValue = 0;
    statusChecked = false;
    error = null;
    response = null;
    $subscriptionStatus: Subscription;

    constructor(
        private data: DataService,
        private user: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private gtService: GoogleTagService,
        public auth: AuthService,
    ) {
        const {redirectUrl} = this.route.snapshot.queryParams;
        if (typeof redirectUrl !== 'undefined' && redirectUrl) {
            this.returnUrl = redirectUrl;
        }
    }

    ngOnInit(): void {
        if (this.data.orderId) {
            setTimeout(() => {
                if (this.data.orderType === 'package') {
                    this.checkStatus();
                } else {
                    this.checkPayPalSubscriptionStatus();
                }
            }, 10);
        } else {
            this.goTo('/pricing');
        }
        // this.checkStatus();

    }

    checkPayPalSubscriptionStatus() {
        const int = setInterval((i) => {
            this.statusValue = Math.round(step * 100 / 9);
            step++;
        }, 1000);
        const timeout = setTimeout(() => {
            this.error = this.errorCodes(null);
            this.statusChecked = true;
        }, 9000);
        let step = 1;
        this.$subscriptionStatus = this.auth.userSubscription()
            .subscribe((docSnapshot: any) => {
                if (docSnapshot.payload.data()?.subscription.activated) {
                    clearTimeout(timeout);
                    this.statusChecked = true;
                    this.onSuccess();
                    this.$subscriptionStatus.unsubscribe();
                }
            });
    }

    checkSubscriptionStatus() {
        const int = setInterval((i) => {
            this.statusValue = Math.round(step * 100 / 9);
            step++;
        }, 1000);
        const timeout = setTimeout(() => {
            this.error = this.errorCodes(null);
            this.statusChecked = true;
        }, 9000);
        let step = 1;

        this.$subscriptionStatus = this.data.checkLiqPaySubscriptionStatus(this.data.orderId)
            .subscribe((docSnapshot: any) => {
                if (docSnapshot.payload.data()?.status.toLowerCase() === 'active') {
                    clearTimeout(timeout);
                    this.statusChecked = true;
                    this.onSuccess();
                    this.$subscriptionStatus.unsubscribe();
                }
            }, (err) => {
                console.log(err);
            });
    }

    checkStatus() {
        this.statusChecked = false;
        this.error = null;
        this.statusValue = 0;
        const pollInterval = 1000; // interval in milliseconds
        const maxRequests = 9;
        const int = interval(pollInterval)
            .pipe(
                startWith(0),
                mergeMap((response, b) => {
                        this.statusValue = Math.round((b + 1) * 100 / maxRequests);
                        if (b === maxRequests - 1 && !this.statusChecked && this.response.status !== 'success') {
                            throw {error: true, message: this.response.status};
                        } else {
                            this.error = null;
                        }
                        return this.user.userSubscription()
                            .pipe(
                                map((res: any) => {
                                    const data = res.payload.data();

                                    this.response = data?.order;
                                    return data?.order;
                                })
                            );
                    }
                ),
                take(maxRequests),
                filter((response: any) => response.status.toLowerCase() === 'hold' || response.status.toLowerCase() === 'captured')
            )
            .subscribe(() => {
                this.error = null;
                int.unsubscribe();
                this.onSuccess();
            }, (error: any) => {
                int.unsubscribe();
                this.statusValue = 100;
                setTimeout(() => {
                    this.error = this.errorCodes(error.message);
                    this.statusChecked = true;
                }, 1000);
            });
    }

    onSuccess() {
        this.statusValue = 100;
        const pb = document.getElementsByClassName('progress-bar-animated')[0] as HTMLElement;
        pb.style.transitionDuration = '100ms';
        this.data.orderId = null;
        this.data.orderType = null;
        this.gtService.event('payment_success')
            .then(this.sleeper(500))
            .then(() => {
                this.statusChecked = true;
                this.goTo(this.returnUrl);
                // this.openSuccessModal();
            });
    }

    sleeper(ms) {
        return (x) => {
            return new Promise(resolve => setTimeout(() => resolve(x), ms));
        };
    }

    errorCodes(prop) {
        const c = {
            error: 'Неуспішний платіж. Некоректно заповнені дані',
            failure: 'Неуспішний платіж',
            reversed: 'Платіж повернений',
            subscribed: 'Підписка успішно оформлена',
            success: 'Успішний платіж',
            unsubscribed: 'Підписка успішно деактивована',
        };

        return c[prop] || 'Нажаль, щось пішло не так';
    }

    goTo(url: string) {
        this.data.orderId = null;
        this.data.orderType = null;
        this.router.navigate([url]);
    }

    // openSuccessModal() {
    //     const modalRef = this.modalService.open(PaymentSuccessComponent, {
    //         centered: true,
    //         size: 'md',
    //         windowClass: 'modal login',
    //         backdrop: 'static',
    //         keyboard: true
    //     });
    //     modalRef.componentInstance.returnUrl = this.returnUrl;
    //     return modalRef.result;
    // }
}
